import React from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import VisibilitySensor from 'react-visibility-sensor';

import FeatureIcon3 from '../icons/feature3-icon';
import Heading3 from '../titles/Heading3';
import Paragraph from '../paragraphs/Paragraph';
//import Button from '../buttons/button';

class Feature3Item extends React.Component {

    constructor() {
        super();
        this.state = {
            animated : false,
            animationClasses : ['feature'],
        };
        this.headerVisible = this.headerVisible.bind(this);
    }

    headerVisible(isVisible) {
        if (isVisible) {
            if (!this.state.animated) {
                var elemIndex = this.props.index,
                timeDelay =+ elemIndex * 200;
                setTimeout(function() { 
                    var classes = this.state.animationClasses;
                    classes.push('animate-box');
                    classes.push('fadeInUp');
                    classes.push('animated-fast');
                    this.setState({ animated: true, animationClasses: classes});
                }.bind(this), timeDelay);
            }
        }
    };

    render () {
        return (
            <VisibilitySensor partialVisibility={ true } onChange={ this.headerVisible } >
                <div className={this.props.value.class + ' '+this.state.animationClasses.join(' ')} style={ { opacity : 0 } }>
                    <div className="feature-inner" >
                        <FeatureIcon3 iconName={ this.props.value.icon }/>
                        <Heading3 title={ this.props.value.title } />
                        <Paragraph text={ this.props.value.description }/>
                        <a className={ this.props.value.buttonClass } href={this.props.value.buttonLink} >{ this.props.translate(this.props.value.buttonText) }</a>
                    </div>
                </div>
            </VisibilitySensor>
        );
    };
};

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(Feature3Item);


// WEBPACK FOOTER //
// ./src/components/features/feature3-item.jsx